export const environment = {
    production: true,
    baseUrl: 'https://sgf2.sistemaindustria.com.br/api-documentos-ajuda/documentos-ajuda',
    nome: 'ambiente'
  };
